<footer class="SubmitClaims__Footer">
  @if (selectedTabIndex === 0) {
    <div class="container u-flex u-wrap u-justifyBetween u-alignCenter u-maxY">
      <div class="SubmitClaims__ClaimsTotal">
        {{ footerConfig?.totalClaimText }}
        <h6 class="SubmitClaims__ClaimsAmount">
          {{ totalClaimLineCharges | currency }}
        </h6>
      </div>
      <div class="SubmitClaims__ClaimsButtons">
        @if (footerConfig?.save) {
          <zip-button
            class="SubmitClaims__SaveButton SubmitClaims__ClaimsButton"
            [config]="footerConfig?.save"
            (zipButtonClicked)="saveClaim()"
            data-test-id="submitClaimsSaveButton"
          ></zip-button>
        }
        <zip-button
          class="SubmitClaims__ClaimsButton"
          [config]="footerConfig?.review"
          (zipButtonClicked)="reviewClaim()"
          [disabled]="ifFormValid"
          data-test-id="submitClaimsReviewButton"
        ></zip-button>
      </div>
    </div>
  }
  @if (selectedTabIndex === 1) {
    <div class="container">
      @if (selectedTabIndex === 1) {
        <div class="SubmitClaims__ClaimsButtons">
          <zip-button
            class="SubmitClaims__SaveButton SubmitClaims__ClaimsButton"
            [config]="footerConfig?.back"
            (zipButtonClicked)="backToForm()"
            data-test-id="submitClaimsBackButton"
          ></zip-button>
          <zip-button
            class="SubmitClaims__ClaimsButton"
            [config]="footerConfig?.submit"
            (zipButtonClicked)="submitClaim()"
            [disabled]="!submitButtonEnabled"
            data-test-id="submitClaimsSubmitButton"
          ></zip-button>
        </div>
      }
    </div>
  }
</footer>
